import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconCheckFilled: FC<IconProps> = ({ $size, $isOuterLayerExist = true, ...rest }) => (
  <IconNonFilledStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 14 14" fill="none">
      {$isOuterLayerExist && <circle cx="7" cy="7" r="7" fill="white" />}
      <path
        d="M6.2625 9.275L9.8 5.7375L9.225 5.175L6.2625 8.1375L4.7625 6.6375L4.2 7.2L6.2625 9.275ZM7 12C6.31667 12 5.67083 11.8687 5.0625 11.6062C4.45417 11.3438 3.92292 10.9854 3.46875 10.5312C3.01458 10.0771 2.65625 9.54583 2.39375 8.9375C2.13125 8.32917 2 7.68333 2 7C2 6.30833 2.13125 5.65833 2.39375 5.05C2.65625 4.44167 3.01458 3.9125 3.46875 3.4625C3.92292 3.0125 4.45417 2.65625 5.0625 2.39375C5.67083 2.13125 6.31667 2 7 2C7.69167 2 8.34167 2.13125 8.95 2.39375C9.55833 2.65625 10.0875 3.0125 10.5375 3.4625C10.9875 3.9125 11.3438 4.44167 11.6062 5.05C11.8687 5.65833 12 6.30833 12 7C12 7.68333 11.8687 8.32917 11.6062 8.9375C11.3438 9.54583 10.9875 10.0771 10.5375 10.5312C10.0875 10.9854 9.55833 11.3438 8.95 11.6062C8.34167 11.8687 7.69167 12 7 12Z"
        fill={colors[rest?.$color]}
      />
    </svg>
  </IconNonFilledStyled>
);

IconCheckFilled.defaultProps = iconDefaultProps;
IconCheckFilled.displayName = 'IconCheckFilled';

export default IconCheckFilled;
